<template>
  <label class="system-choice-control" :class="checked ? 'checked' : ''">
    <input
      class="system-choice-input"
      :type="type"
      :name="name"
      :value="value"
      :checked="checked"
      @change="$emit('change')"
    />
    <span class="system-choice-indicator"></span>
  </label>
</template>

<script>
export default {
  name: 'SystemChoiceControl',
  props: {
    type: {
      type: String,
      default: 'radio'
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.system-choice-control {
  position: relative;
  width: 16px;
  height: 16px;
  margin: 2px 8px 0 0;
  cursor: pointer;
  flex-shrink: 0;
}

.system-choice-input {
  position: absolute;
  inset: 0;
  opacity: 0;
  margin: 0;
  cursor: pointer;
}

.system-choice-indicator {
  position: absolute;
  inset: 0;
  border: 1px solid #8ea09a;
  background: #fff;
  transition: all 0.2s ease;
}

.system-choice-input[type='radio'] + .system-choice-indicator {
  border-radius: 50%;
}

.system-choice-input[type='checkbox'] + .system-choice-indicator {
  border-radius: 4px;
}

.checked .system-choice-indicator {
  border-color: #668269;
  box-shadow: 0 0 0 2px rgba(102, 130, 105, 0.18);
}

.system-choice-input[type='radio']:checked + .system-choice-indicator::after {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #668269;
  top: 3px;
  left: 3px;
}

.system-choice-input[type='checkbox']:checked + .system-choice-indicator::after {
  content: '';
  position: absolute;
  width: 4px;
  height: 8px;
  border: solid #668269;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  left: 5px;
  top: 2px;
}
</style>
